// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"864":"164cfc9e","992":"7b6cee7a"}[chunkId] + ".css";
};